import { render } from "./registration.vue?vue&type=template&id=f9488ca2"
import script from "./registration.js?vue&type=script&lang=js"
export * from "./registration.js?vue&type=script&lang=js"

import "./registration.vue?vue&type=style&index=0&id=f9488ca2&lang=scss"

import exportComponent from "/builds/pleroma/pleroma-fe/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__